import styled from "styled-components";

export const CarouselContainer = styled.div`
  overflow: visible;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 ${({ theme }) => theme.CONSTANTS.XW * 5}px;
`;

export const ScrollWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.CONSTANTS.XW * 2}px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  padding: ${({ theme }) => theme.CONSTANTS.XW * 2}px 0;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 1025px) {
    gap: ${({ theme }) => theme.CONSTANTS.XW * 1}px;
  }
`;

export const WallpaperCard = styled.div<{ $active?: boolean }>`
  flex: 0 0 auto;
  width: ${({ $active }) => ($active ? "40%" : "80px")};
  border-radius: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  overflow: hidden;
  scroll-snap-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: ${({ $active, theme }) =>
    $active ? `3px solid ${theme.THEME.neonBlue}` : "2px solid transparent"};
  box-shadow: ${({ $active, theme }) =>
    $active ? `0 0 10px ${theme.THEME.neonBlue}` : "none"};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media (min-width: 1025px) {
    width: ${({ $active }) => ($active ? "12%" : "9%")};
  }
`;
